module.exports = __webpack_public_path__ + "static/media/card.0f57a120.svg";